import { render, staticRenderFns } from "./InventoryManagementView.vue?vue&type=template&id=4b29d196&scoped=true"
import script from "./InventoryManagementView.vue?vue&type=script&lang=js"
export * from "./InventoryManagementView.vue?vue&type=script&lang=js"
import style0 from "./InventoryManagementView.vue?vue&type=style&index=0&id=4b29d196&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b29d196",
  null
  
)

export default component.exports